<template>
  <v-container class="contenedor-ppal">
    <v-overlay :value="sisi">
      <div class="loader"></div>
    </v-overlay>

    <!-- INFORMACION TOOLBAR  -->
    <v-card elevation="4" class="mb-5">
      <v-toolbar flat elevation="4">
        <v-card class="icon">
          <v-icon
            style="margin-left: 30px; margin-top: 25px"
            color="white"
            x-large=""
            >mdi-clipboard-text</v-icon
          >
        </v-card>
        <div class="usuario">REPORTES FIN TURNO</div>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>
    <!-- CAMPOS PARA FILTRADO POR FECHA -->
    <v-card class="mt-5">
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateInit"
                  label="Fecha inicio"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateInit"
                @input="menu1 = false"
                locale="es"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="3">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateEnd"
                  label="Fecha final"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateEnd"
                @input="menu2 = false"
                locale="es"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col
            :cols="reportes.length != 0 ? 3 : 5"
            :class="
              reportes.length != 0
                ? 'd-flex justify-center align-center mb-2'
                : 'd-flex justify-start align-center mb-2'
            "
          >
            <v-btn
              :disabled="!dateInit"
              @click="searchReports"
              color="#111c3d"
              dark
            >
              <v-icon left>mdi-magnify</v-icon>
              Consultar
            </v-btn>
          </v-col>

          <v-col cols="3" class="d-flex justify-center align-center mb-2">
            <div v-if="reportes.length != 0">
              <v-btn
                :loading="loading3"
                :disabled="loading3"
                color="green darken-3"
                class="ma-2 white--text"
                @click="downloadExcel"
              >
                <v-icon left> mdi-file-excel </v-icon>
                EXPORTAR EXCEL
                <template v-slot:loader>
                  Exportando...
                  <span class="custom-loader">
                    <v-icon light>mdi-reload</v-icon>
                  </span>
                </template>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>


    <!-- DATA TABLE LISTADO DE REPORTES -->
    <v-text-field
      v-if="reportes != 0"
      v-model="search"
      append-icon="mdi-magnify"
      label="Filtrar busqueda"
      class="text-field"
      single-line
      color="#111c3d"
    ></v-text-field>
    <br />
    <!-- tabla donde se pintan los datos obtenidos del arreglo -->
    <v-data-table
      :headers="headers"
      :items="reportes"
      :search="search"
      style="border: 2px solid #111c3d"
      class="elevation-3"
    >



      <template v-slot:no-data>
        <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined
          >No hay informacion para mostrar</v-alert
        >
      </template>
    </v-data-table>
   
    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
      color="#111c3d"
      style="color: white"
    >
      {{ text }}
      <v-btn color="#111c3d" depressed @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import env from "../../env";
import swal from "sweetalert";
import XLSX from "xlsx";

export default {
  name: "Fecha",
  data: () => ({
    //Varibales de uso para el snackbar
    snackbar: false,
    y: "top",
    x: null,
    mode: "",
    timeout: 6000,
    text: "",
    //Variables de uso para obtener lista de fechas
    dateInit: "",
    dateEnd: new Date().toISOString().substr(0, 10),
    menu1: false,
    menu2: false,
    sisi: false,
    headers: [
      {
        text: "Fecha",
        align: "left",
        value: "fecha",
        align: "center",
        class: "column",
      },
      {
        text: "Hora",
        align: "left",
        value: "hora",
        align: "center",
        class: "column",
      },
      {
        text: "Cargo",
        value: "nombreCargo",
        align: "center",
        class: "column",
      },
      {
        text: "CEDULA",
        align: "left",
        value: "cedula",
        align: "center",
        class: "column",
      },
      {
        text: "Nombre",
        value: "nombrevi",
        align: "center",
        class: "column",
      },
      {
        text: "CodSeta PV",
        value: "codigoseta",
        align: "center",
        class: "column",
      },
      {
        text: "NombrePV",
        value: "nombrepv",
        align: "center",
        class: "column",
      },



    ],
    reportes: [],
    search: "",
    dialog: false,

    //Variables de uso para exportar a excel
    nameFile: "",
    loader: null,
    loading3: false,
    chatItem: [],
  }),
  methods: {


    downloadExcel() {
      this.loading3 = true;
      const reportes = [];
      try {
        for (let i = 0; i < this.reportes.length; i++) {
          const item = {};
          item.ID_visita = this.reportes[i].idvisita;
          item.Fecha_Visita = this.reportes[i].fecha;
          item.Hora_Visita = this.reportes[i].hora;// se agrega cedula origen o asesor
          item.Area = this.reportes[i].cc_nombre_area
          item.Cargo_Visitante = this.reportes[i].nombreCargo;
          item.Cedula_Visitante = this.reportes[i].cedula;// se agrega nombre origin o asesor
          item.Nombre_Visitante = this.reportes[i].nombrevi;// se agrega municipio
          item.Codigo_Seta = this.reportes[i].codigoseta;
          item.Nombre_puntov = this.reportes[i].nombrepv;
          item.Municipio = this.reportes[i].direccion;
          //item.Cedula_Asesor = this.reportes[i].cedulavendedor;
          //item.Nombre_Asesor=this.reportes[i].nombreasesor;  
          console.log();
          reportes.push(item);     
         }
      } catch (error) {
        console.log(error);
        this.loading3 = false;
      }
      const dataSheet = XLSX.utils.json_to_sheet(reportes);
      // Definir tamaños de columnas para visitaspvSheet
      const visitaspvSheetColumnSizes = [
        //ANCHOS COLUMNA
            { wch: 8 }, // ID VISITA
            { wch: 11 }, // FECHA
            { wch: 10 }, // HORA
            { wch: 14 }, // AREA
            { wch: 26}, //CARGO
            { wch: 14 },  //CEDULA
            { wch: 33 },  //nombre visitnte
            { wch: 11 },  //CODIGO SETA
            { wch: 29 }, // NOMBRE PV
            { wch: 22 },  //municipio
            //{ wch: 15 },  //cedlua asesor
            //{ wch: 33 }, //nombre asesor
            // Añadir más objetos con la propiedad wch para definir más tamaños de columnas según sea necesario
        ];
        dataSheet['!cols'] = visitaspvSheetColumnSizes;

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataSheet, "Visitas Por Usuarios");
      XLSX.writeFile(wb, `Reporte fin turnos del ${this.dateInit} al ${this.dateEnd}.xlsx`);
      this.loading3 = false;
    },
    /**
     * Metodo que busca todos los reportes por dos fechas
     */
    searchReports() {
      this.sisi = true;
      const fechaInicio = this.dateInit;
      const fechaCierre = this.dateEnd;
      const id = localStorage.getItem("id");


      //tranforma los datos string en DATE para realiar operacion de contar dias
      const fechaIniciod = new Date(fechaInicio);
      const fechaCierred = new Date(fechaCierre);

      // Calcula la diferencia en milisegundos
      const diferenciaMilisegundos = fechaCierred - fechaIniciod;

      // Convierte la diferencia de milisegundos a días
      const diferenciaDias = diferenciaMilisegundos / (1000 * 3600 * 24); 

      if (fechaInicio > fechaCierre){

        this.snackbar = true;
        this.text =
          "Error, esta ingresando una fecha de inicio mayor a la final";
        this.dateInit = "";
        this.reportes = [];
        this.nameFile = "";
        this.sisi = false;
      }
      //dias maximos de consulta
      if (diferenciaDias > 31) {

        this.snackbar = true;
        this.text =
          "Error, No puede consultar mas de 1 Mes";
        this.dateInit = "";
        this.reportes = [];
        this.nameFile = "";
        this.sisi = false;      
      } else {
        axios
          .get(
            `${env.endpoint}VisitasNew/reporteFecha2?fechaInicio=${fechaInicio}&fechaFinal=${fechaCierre}`
          )
          .then((res) => {
            // console.log(res.data);
            this.sisi = false;
            this.reportes = res.data;
            this.nameFile = `Visitasdel ${fechaInicio} al ${fechaCierre}`;
          })
          .catch((error) => {
           
            console.log();
          }); 
          
      }
      
    },
    /**
     * Metodo que activa la mnodal y muestra la conversacion
     */
    showDetails(item) {
      this.dialog = true;
      const data = JSON.parse(JSON.stringify(item));
      this.chatItem = JSON.parse(data.conversacion);
    },
    /**
     * Metodo que elimina un reporte que no fue cerrado correctamente por el bot
     */
    deleteReport(item) {
      swal({
        title: "Este registro sera eliminado permanentemente.",
        text: "Una vez eliminado no se podra recuperar.",
        icon: "warning",
        buttons: ["Cancelar", true],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          console.log(item.cc_id_caso);

          axios
            .get(`${env.endpoint}callcenter/delete_caso?id=${item.cc_id_caso}`)
            .then((res) => {
              this.searchReports();
            })
            .catch((error) => {
              console.log();
            });
          swal("Registro eliminado con exito!", {
            icon: "success",
          });
        } else {
          swal("Proceso de eliminacion cancelado");
        }
      });
    },
    getColor(oculto, cerrados) {
      if (oculto == 0 && cerrados == 0) return "red darken-2";
      else return "green darken-3";
    },
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    },
  },
};
</script>

<style>
.text-field {
  border: 2px solid #111c3d;
  padding: 5px;
  border-radius: 5px;
}

.contenedor-ppal {
  border: 1px solid #8b91a5;
  padding-bottom: 40px !important;
  border-radius: 5px;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 50px;
  padding: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #b6c1ce;
  --_m: 
    conic-gradient(#0000 10%,#000),
    linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
          mask: var(--_m);
  -webkit-mask-composite: source-out;
          mask-composite: subtract;
  animation: l3 1s infinite linear;
}
@keyframes l3 {to{transform: rotate(1turn)}}
</style>
